var map = {
	"./anti-covid-19.svg": "cc7f",
	"./aperto_maos.svg": "4b38",
	"./colocar_avisos.svg": "fe9e",
	"./covid-19.svg": "937b",
	"./delivery2_green.svg": "7b94",
	"./delivery3_green.svg": "9951",
	"./delivery_green.svg": "eb6c",
	"./identificar_sintomas.svg": "8ac4",
	"./kit.svg": "cdfe",
	"./lavar_maos_green.svg": "1fcc",
	"./lavar_mascara_green.svg": "16c1",
	"./lencos.svg": "674a",
	"./limpar_pagamentos.svg": "7e4a",
	"./market2_green.svg": "a123",
	"./market3_green.svg": "6200",
	"./market4_green.svg": "a581",
	"./market_green.svg": "9ba1",
	"./mascaras_green.svg": "e62c",
	"./motoboy_green.svg": "889a",
	"./nao_mexer_mascara.svg": "d014",
	"./nao_mexer_mascara2.svg": "0b82",
	"./nao_trocar_objetos.svg": "6b72",
	"./nap_trabalhar_doente.svg": "e840",
	"./produtos_higiene_green.svg": "c3bf",
	"./sem_aglomeracao.svg": "5b00",
	"./shield_covid_green.svg": "eb28",
	"./tosse.svg": "bf54",
	"./tosse_cotovelo_green.svg": "ef5b",
	"./tosse_lenco.svg": "32eb",
	"./use_epi.svg": "e13c",
	"./use_mascara.svg": "9e16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a731";